import './styles.css';
export var consumerLoadingStyle = {position:'absolute',top:0,width:'100%',height:'100%',zIndex:1,pointerEvents:'none',backgroundColor:'var(--dt-colors-background-base-default, #fafafb)',opacity:0.4};
export var container = '_16sdwow0-3-15-1';